'use client';

import React from 'react';

import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { BlogArticleCard } from '@/components/BlogArticleCard';
import { ErrorMessage } from '@/components/ErrorMessage';
import { useBlogArticles } from '@/modules/blog/hooks/useBlogArticles';
import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';

export function PaginatedArticlesList() {
  const t = useTranslations('blog');
  const { data, fetchNextPage, isEnd, isFetchingNextPage } = useBlogArticles();
  const { sendBlogInteractionActionEvent } = useBlogTracking();

  function handleShowMoreClick() {
    fetchNextPage();
    sendBlogInteractionActionEvent({
      interactionType: 'ShowMorePaginationClicked',
    });
  }

  if (!data?.pages) {
    return (
      <ErrorMessage className={styles.error}>
        {t('Error.Articles.RequestFailed')}
      </ErrorMessage>
    );
  }

  return (
    <>
      <ul className={styles.list}>
        {data.pages?.map((articles) =>
          articles?.map((article) => (
            <li key={article.slug}>
              <BlogArticleCard
                slug={article.slug}
                title={article.title}
                publishedAt={article?.publishedAt}
                imgSrc={article.thumbnail?.url}
                imgAlt={article.thumbnail?.description}
              />
            </li>
          ))
        )}
      </ul>
      {!isEnd && (
        <div className={styles.paginationButtonContainer}>
          <Button
            className={styles.paginationButton}
            onClick={handleShowMoreClick}
            isLoading={isFetchingNextPage}
            disabled={isFetchingNextPage}
          >
            {t('Pagination.Next')}
          </Button>
        </div>
      )}
    </>
  );
}
